var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 566,
    viewBox: "0 0 564 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1341_3692)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.983 45.4528L150.643 43.8976M136.061 43.068L126.742 42.5383",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.006 349.807L197.897 526.105H236.707L333.375 397.879L376.316 397.879C383.769 397.879 389.809 391.839 389.809 384.386L389.809 370.873C389.809 363.42 383.769 357.38 376.316 357.38H363.887L399.494 322.067C399.494 322.067 537.128 316.045 537.119 283.137C537.119 250.239 399.493 244.226 399.493 244.226L261.988 244.226L128.713 257.197L76.4186 202.149L40.858 202.149L62.9161 276.804L40.877 283.147L62.9344 289.471L40.8763 364.127L76.4374 364.126L128.731 309.116L262.006 322.085L262.006 349.807Z",
    fill: "#76C0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.508 244.234L363.902 208.922L376.331 208.922C383.784 208.922 389.825 202.882 389.824 195.428L389.815 181.944C389.815 174.49 383.775 168.451 376.322 168.45L333.38 168.45L236.704 40.2155L197.903 40.2246L262.012 216.522L262.012 244.244L128.737 257.214L76.4425 202.166L40.8911 202.175L62.9493 276.831L40.8911 283.155L537.152 283.146C537.152 250.265 399.508 244.234 399.508 244.234Z",
    fill: "#5197B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.913 526.1H236.724L333.381 397.883L363.911 357.385L399.518 322.072L262.03 322.072L262.021 349.803L197.913 526.1Z",
    fill: "#63A4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.903 208.937L333.373 168.438L236.706 40.2123L197.905 40.2215L262.013 216.52L262.013 244.241L399.509 244.231L363.903 208.937Z",
    fill: "#63A4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9407 289.49L40.8825 364.146L76.4337 364.136L128.729 309.106L62.9407 289.49Z",
    fill: "#63A4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9388 276.832L40.8809 202.177L76.4323 202.168L128.727 257.197L62.9388 276.832Z",
    fill: "#63A4CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.544 522.5L148.203 520.944M133.622 520.115L124.303 519.585",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1341_3692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 564,
    height: 566,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.65e7df5480c0bfca63f0e04c4e0b5843.svg";
export { ForwardRef as ReactComponent };